import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  view: 'login',
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  phone: '',
  data: null,
  reducers: {
    openModal: (state, action) => {
      console.log("openModal", action);
      state.open = true;
      state.view = action.payload.view;
      state.data = action.payload.data || null;
    },
    closeModal: (state) => {
      state.open = false;
      state.view = null;
      state.data = null;
    },

    // 👇 ADD THESE
    openContact: (state) => {
      state.contactOpen = true;
    },
    closeContact: (state) => {
      state.contactOpen = false;
    },
    toggleContact: (state) => {
      state.contactOpen = !state.contactOpen;
    },
  },
});

export const { openModal, closeModal, openContact, closeContact, toggleContact } = profileSlice.actions;

export default profileSlice.reducer;
